import { render, staticRenderFns } from "./ForecastReportSales.vue?vue&type=template&id=2f098a07&scoped=true"
import script from "./ForecastReportSales.vue?vue&type=script&lang=js"
export * from "./ForecastReportSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f098a07",
  null
  
)

export default component.exports